export const ACTIVE_YEAR = 2022;
export const HOTLINE = '028 7300 3588';
export const CSEmail = 'chamsoc.pcgd@hcm.edu.vn';
